import React, { useRef, useEffect } from 'react';
import {Text, RichText, Image } from "@sitecore-jss/sitecore-jss-react";
import classNames from "classnames";
import { getOverallSettingsClasses, mobileIs, componentId } from "../../utils/siteUtils";
import Swiper from 'swiper';
import './style.scss';


const MultiSwiper = ({ rendering, fields, page }) => {
  const {
    title,
    pc_text,
    pc_rows,
    m_text,
    m_rows,
  } = fields;
  const isAR = page?.fields?.rtl?.value;
  const isMobile = mobileIs();
  const rows = isMobile ? m_rows : pc_rows;
  const swiperInstancesRef = useRef([]);

  useEffect(() => {
    if (swiperInstancesRef.current.length > 0) {
      swiperInstancesRef.current.forEach(swiper => swiper.destroy());
      swiperInstancesRef.current = [];
    }

    const swiperEls = document.querySelectorAll('.flow-swiper');

    swiperEls.forEach((container, index) => {
      const fSwiper = new Swiper(container, {
        slidesPerView: 30,
        loop: true,
        freeMode: true,
        speed: 500,
        spaceBetween: 0,
        breakpoints: {
          360: {
            slidesPerView: 10,
          },
          640: {
            slidesPerView: 30
          },
          1024: {
            slidesPerView: 40
          }
        },
        autoplay: {
          delay: 0,
          reverseDirection: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
          waitForTransition: false
        },
        on: {
          afterInit: function(swiper) {
            const handleMouseEnter = function(e) {
              if (swiper.autoplay) {
                swiper.setTranslate(swiper.translate * (index % 2 === Number(isAR) ? -1 : 1));
                swiper.autoplay.stop();
              }
            };
            const handleMouseLeave = function() {
              if (swiper.autoplay) {
                container.querySelector('.swiper-wrapper').classList.remove('quick-forward');
                swiper.autoplay.start();
              }
            };

            container.addEventListener('mouseenter', handleMouseEnter);
            container.addEventListener('mouseleave', handleMouseLeave);
          },
        }
      });


      swiperInstancesRef.current.push(fSwiper);
    });

    return () => {
      swiperInstancesRef.current.forEach((swiper) => {
        swiper.el.removeEventListener('mouseenter', swiper.handleMouseEnter);
        swiper.el.removeEventListener('mouseleave', swiper.handleMouseLeave);
        swiper.destroy();
      });
    };
  });



  const rootClasses = classNames("multi-swiper", getOverallSettingsClasses(fields));
  const rootId = componentId(rendering);

  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} id={rootId}>
      <div className='q-container'>
        <Text className="component-title" tag="h2" field={title}/>
        <RichText className="component-sub-title" tag="div" field={isMobile && m_text ? m_text : pc_text} />
      </div>
      
      {
        rows.length && rows.map((row, index) => {
          if (!row?.fields?.items?.length) {
            return false;
          }

          const dupArray = [...row.fields.items, ...row.fields.items, ...row.fields.items];
          const filledArray = [];
          dupArray.forEach(item => {
            filledArray.push(item);

            for (let i = 0; i < 9; i++) {
              filledArray.push(null);
            }
          });

          return <div  className={`flow-swiper fs-${index}`} key={index} dir={index % 2 === Number(isAR) ? 'rtl' : 'ltr'}>
            <div className='swiper-wrapper'>

              {
                filledArray.map((item, idx) => {
                    return <div className={`swiper-slide ${idx % 10 === 0 ? 'real-slide' : ''}`} key={idx}>
                       {(idx % 10 === 0) && <Image field={isMobile ? item.fields.m_image : item.fields.pc_image} />}
                    </div>
                })
              }

            </div>
          </div>
        })
      }

    </div>
  );
}


export default MultiSwiper;